import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Raffle } from './raffle'
import { raffleActions } from './raffle.actions'
import * as fromRaffle from './raffle.reducer'
import { RaffleService } from './raffle.service'

@Injectable()
export class RaffleEffects extends ResourceEffects<Raffle> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public raffleService: RaffleService
  ) {
    super(fromRaffle.FEATURE_NAME, raffleService, raffleActions, actions$)
  }
}
